import { useEffect, useRef } from 'react';

export function NotFoundPage() {
  const headingRef = useRef<HTMLHeadingElement | null>(null);

  // Move focus to the heading on mount so screen-reader + keyboard users
  // land directly in the page content (not the doc body).
  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="not-found-pane">
      <div className="not-found-card" role="alert">
        <p className="not-found-eyebrow">404</p>
        <h1 ref={headingRef} tabIndex={-1}>
          Page not found
        </h1>
        <p>
          The URL <code className="not-found-path">{window.location.pathname}</code>{' '}
          doesn't match any page.
        </p>
        <p className="not-found-hint">
          Check the link — or head back to Tizok.
        </p>
        <a href="/" className="login-form-submit">
          Back to Tizok
        </a>
      </div>
    </div>
  );
}
